













































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { SnsEndpoint, Subscription } from '@/types/core-push';

import tippy from 'tippy.js';

import VueError from '@/components/VueError.vue';
import EnterpriseId from '@/components/EnterpriseId.vue';
import TimestampAgo from '@/components/TimestampAgo.vue';
import HttpEndpointView from '@/components/subscriptions/HttpEndpointView.vue';
import SnsEndpointView from '@/components/subscriptions/SnsEndpointView.vue';
import KinesisEndpointView from '@/components/subscriptions/KinesisEndpointView.vue';
import IotCoreEndpointView from '@/components/subscriptions/IotCoreEndpointView.vue';
import SubFilters from '@/components/subscriptions/SubFilters.vue';
import {Column} from "@/types/core";
import MobileFriendlyRow from "@/components/MobileFriendlyRow.vue";
import AzureEventHubEndpointView from "@/components/subscriptions/AzureEventHubEndpointView.vue";
import MqttEndpointView from "@/components/subscriptions/MqttEndpointView.vue";


@Component({
  components:{
    MobileFriendlyRow,
    VueError,
    EnterpriseId,
    HttpEndpointView,
    SnsEndpointView,
    KinesisEndpointView,
    IotCoreEndpointView,
    AzureEventHubEndpointView,
    MqttEndpointView,
    SubFilters,
    TimestampAgo
  }
})
export default class SubRow extends Vue {

  @Prop({ default: {},  type: Object}) sub!: Subscription;
  @Prop({ default: 0,  type: Number}) index!: number;

  cols:Column[] = [
    { colKey: 'subscriptionId', colName: 'sub id', colStyle: {width: '10%', 'min-width':'55px'} },
    { colKey: 'enterpriseId', colName: 'enterpriseId', colStyle: {'flex-grow':1}},
    { colKey: 'type', colName: 'type', colStyle: {width: '15%', 'min-width':'55px'}}
  ]
  // internal dependencies
  error:string = '';
  
  async mounted() {
    // nothing here yet
    tippy('[data-tippy-content]');
    
  }

}
